import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e49ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default-game-root" }
const _hoisted_2 = { class: "video-and-bet-view-container" }
const _hoisted_3 = { class: "left-content" }
const _hoisted_4 = { class: "video-wraps" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "videoplayer1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", { id: "videoplayer2" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "video-loader"
}
const _hoisted_8 = { class: "div" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "m-timer-and-table-info" }
const _hoisted_11 = { class: "top" }
const _hoisted_12 = { class: "bottom" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "m-notice" }
const _hoisted_15 = { class: "tables-and-notice" }
const _hoisted_16 = { class: "tables-wrap" }
const _hoisted_17 = ["data-label"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["data-label"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["data-label"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "notice-wrap" }
const _hoisted_24 = { class: "right-content" }
const _hoisted_25 = { class: "logo-and-time-limit" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" })
], -1))
const _hoisted_27 = { class: "timer-and-status" }
const _hoisted_28 = { class: "status" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "br-line" }, null, -1))
const _hoisted_30 = { class: "timer" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "value" }, "200000", -1))
const _hoisted_33 = { class: "label" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "label" }
const _hoisted_37 = { class: "value" }
const _hoisted_38 = { class: "label" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "label" }
const _hoisted_41 = { class: "value" }
const _hoisted_42 = { class: "label" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "total-bet-and-total-winloss" }
const _hoisted_45 = { class: "total-bet-group" }
const _hoisted_46 = { class: "label1" }
const _hoisted_47 = { class: "value1" }
const _hoisted_48 = { class: "total-winloss-group" }
const _hoisted_49 = { class: "label1" }
const _hoisted_50 = { class: "value1" }
const _hoisted_51 = { class: "chips-and-confirm-cancel-button" }
const _hoisted_52 = { class: "road-map-container" }
const _hoisted_53 = { class: "pc-pediction rght" }
const _hoisted_54 = ["data-label", "data-value"]
const _hoisted_55 = ["data-label", "data-value"]
const _hoisted_56 = ["data-label", "data-value"]
const _hoisted_57 = ["data-label", "data-value"]
const _hoisted_58 = ["data-label", "data-value"]
const _hoisted_59 = { class: "prediction-sumary" }
const _hoisted_60 = { class: "prediction" }
const _hoisted_61 = { class: "sumary" }
const _hoisted_62 = ["label"]
const _hoisted_63 = ["label"]
const _hoisted_64 = ["label"]
const _hoisted_65 = ["label"]
const _hoisted_66 = ["label"]
const _hoisted_67 = { class: "pc-pediction lft" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_video = _resolveComponent("icon-video")!
  const _component_icon_sound = _resolveComponent("icon-sound")!
  const _component_icon_arrow_lelft = _resolveComponent("icon-arrow-lelft")!
  const _component_icon_down = _resolveComponent("icon-down")!
  const _component_marquee_text = _resolveComponent("marquee-text")!
  const _component_bet_group = _resolveComponent("bet-group")!
  const _component_chips_control = _resolveComponent("chips-control")!
  const _component_road_map = _resolveComponent("road-map")!
  const _component_m_prediction = _resolveComponent("m-prediction")!
  const _component_prediction = _resolveComponent("prediction")!
  const _component_card_result = _resolveComponent("card-result")!
  const _component_m_card_result = _resolveComponent("m-card-result")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          (_ctx.isLoadingVideo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["media-tools", { on: _ctx.showMediaTools }])
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_icon_video, {
                class: "v",
                "is-on": _ctx.videoIsOn,
                onClick: _withModifiers(_ctx.onSetVideo, ["prevent"])
              }, null, 8, ["is-on", "onClick"]),
              _createVNode(_component_icon_sound, {
                class: "s",
                "is-on": _ctx.soundIsOn === 1,
                onClick: _withModifiers(_ctx.onSoundClicked, ["prevent"])
              }, null, 8, ["is-on", "onClick"]),
              _createVNode(_component_icon_arrow_lelft, {
                class: "a",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                                    _ctx.showMediaTools = !_ctx.showMediaTools
                                ), ["prevent"]))
              })
            ])
          ], 2),
          _createElementVNode("div", {
            class: "m-limit-info",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('show-limit', _ctx.deskData?.gameType ?? 1)))
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(`${_ctx.limit?.Min ?? '0'}-${_ctx.limit?.Max ?? '0'}`), 1),
            _createVNode(_component_icon_down, { color: '#fff' })
          ]),
          _createElementVNode("div", {
            class: "m-toggle-switch",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('show-select-table')))
          }, _toDisplayString(_ctx.t('game.changetable')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.tableName), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(`${_ctx.t('game.gameid')}: ${_ctx.deskData?.gameId ?? ''}`), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["m-timer", [
                                { 'time-mode': _ctx.currentCount !== -1 },
                                _ctx.timerColor
                            ]]),
              innerHTML: 
                                _ctx.currentCount !== -1
                                    ? _ctx.currentCount
                                    : _ctx.t('common.stpbet')
                            
            }, null, 10, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_marquee_text, {
              class: "c-notice",
              speed: 20
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.ingameNotice), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "bac-tables",
                "data-label": _ctx.t('baccarat.name')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bacDesks, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["btn-table", { active: _ctx.desk === i }]),
                    key: `bac-tables-pc-${i}`,
                    onClick: ($event: any) => (_ctx.enterTable(i, 4))
                  }, " F" + _toDisplayString(i), 11, _hoisted_18))
                }), 128))
              ], 8, _hoisted_17),
              _createElementVNode("div", {
                class: "dra-tables",
                "data-label": _ctx.t('dragontiger.name')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draDesks, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["btn-table", { active: _ctx.desk === i }]),
                    key: `dra-tables-pc-${i}`,
                    onClick: ($event: any) => (_ctx.enterTable(i, 2))
                  }, " F" + _toDisplayString(i), 11, _hoisted_20))
                }), 128))
              ], 8, _hoisted_19)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "vip-tables",
                "data-label": _ctx.t('menu.dealfirst')
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vipDesk, (i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["btn-table", { active: _ctx.desk === i }]),
                    key: `vip-tables-pc-${i}`,
                    onClick: ($event: any) => (_ctx.enterTable(i, 5))
                  }, " F" + _toDisplayString(i), 11, _hoisted_22))
                }), 128))
              ], 8, _hoisted_21)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_marquee_text, {
              class: "notice",
              speed: 20
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.ingameNotice), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", null, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.currentCount === -1
                                        ? _ctx.t('game.stopbetting')
                                        : _ctx.t('game.startbetting')), 1),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.currentCount === -1 ? 0 : _ctx.currentCount), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.t('game.stationlimit')), 1),
              _hoisted_32
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t('common.min')), 1),
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.limit?.Min ?? ''), 1)
              ]),
              (_ctx.deskData?.gameType === 1 || false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.t('common.pairmax')), 1),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.limit?.PairMaxBet ?? ''), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.t('common.tiemax')), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.limit?.TieMaxBet ?? ''), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t('common.max')), 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.limit?.Max ?? ''), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.t('game.gameid')), 1),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.deskData?.gameId ?? ''), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.t('game.totalbet')), 1),
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.totalBet), 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.t('game.totalwin')), 1),
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.winOrLostAmount), 1)
          ])
        ]),
        _createVNode(_component_bet_group, {
          ref: "betView",
          class: "bet-group",
          "game-type": _ctx.deskData?.gameType ?? -1,
          allowBet: _ctx.allowBet,
          redConfirmedBet: _ctx.redConfirmedBet,
          blueConfirmedBet: _ctx.blueConfirmedBet,
          greenConfirmedBet: _ctx.greenConfirmedBet,
          bluePairConfirmedBet: _ctx.bluePairConfirmedBet,
          redPairConfirmedBet: _ctx.redPairConfirmedBet,
          xian: _ctx.xian,
          tableNo: _ctx.desk,
          winresult: _ctx.winner,
          onSessionExpired: _ctx.handleOnSessionExpired,
          onOnUpdateTempBet: _ctx.handleTempBetUpdated
        }, null, 8, ["game-type", "allowBet", "redConfirmedBet", "blueConfirmedBet", "greenConfirmedBet", "bluePairConfirmedBet", "redPairConfirmedBet", "xian", "tableNo", "winresult", "onSessionExpired", "onOnUpdateTempBet"]),
        _createElementVNode("div", _hoisted_51, [
          _createVNode(_component_chips_control, { class: "chips-group" }),
          _createElementVNode("div", {
            class: _normalizeClass(["confirm-cancel-wrap", { hiden: !_ctx.hasUnconfimerBet }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ active: _ctx.hasUnconfimerBet }),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmBet && _ctx.confirmBet(...args)))
            }, _toDisplayString(_ctx.t('game.confirmbet')), 3),
            _createElementVNode("div", {
              class: _normalizeClass({ active: _ctx.hasUnconfimerBet }),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelBet && _ctx.cancelBet(...args)))
            }, _toDisplayString(_ctx.t('game.cancelbet')), 3)
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", {
          class: "s red",
          "data-label": 
                        _ctx.gtype === 1
                            ? _ctx.t('baccarat.banker')
                            : _ctx.t('dragontiger.dragon')
                    ,
          "data-value": _ctx.roadMapData.redCount
        }, null, 8, _hoisted_54),
        _createElementVNode("div", {
          class: "s blue",
          "data-label": 
                        _ctx.gtype === 1
                            ? _ctx.t('baccarat.player')
                            : _ctx.t('dragontiger.tiger')
                    ,
          "data-value": _ctx.roadMapData.blueCount
        }, null, 8, _hoisted_55),
        _createElementVNode("div", {
          class: "s green",
          "data-label": _ctx.t('baccarat.tie'),
          "data-value": _ctx.roadMapData.tieCount
        }, null, 8, _hoisted_56),
        (_ctx.gtype === 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "s red",
              "data-label": _ctx.t('common.pair'),
              "data-value": _ctx.roadMapData.redPairCount
            }, null, 8, _hoisted_57))
          : _createCommentVNode("", true),
        (_ctx.gtype === 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "s blue",
              "data-label": _ctx.t('common.pair'),
              "data-value": _ctx.roadMapData.bluePairCount
            }, null, 8, _hoisted_58))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(), _createBlock(_component_road_map, {
        key: _ctx.pcMapKey,
        ref: "pcMapView",
        class: "road-map",
        "game-type": _ctx.deskData?.gameType || 1,
        "map-data": _ctx.deskData?.result,
        "border-color": '#c0c0c0',
        "enable-prediction": true,
        display: _ctx.deviceOrientation === 'landscape' ? 0 : 1,
        onRoadMapData: _ctx.onRoadMapDataParsed
      }, null, 8, ["game-type", "map-data", "display", "onRoadMapData"])),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createVNode(_component_m_prediction, {
            color: 'red',
            label: 
                            _ctx.gtype === 1
                                ? _ctx.t('game.bankerask')
                                : _ctx.t('game.dragonask')
                        ,
            "map-data": _ctx.nextRedRoadMapSummaryData,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.predict(1)))
          }, null, 8, ["label", "map-data"]),
          _createVNode(_component_m_prediction, {
            color: 'blue',
            label: 
                            _ctx.gtype === 1
                                ? _ctx.t('game.playerask')
                                : _ctx.t('game.tigerask')
                        ,
            "map-data": _ctx.nextBlueRoadMapSummaryData,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.predict(2)))
          }, null, 8, ["label", "map-data"])
        ]),
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", {
            class: "red",
            label: 
                            _ctx.gtype === 1
                                ? _ctx.t('baccarat.banker')
                                : _ctx.t('dragontiger.dragon')
                        
          }, _toDisplayString(_ctx.roadMapData.redCount), 9, _hoisted_62),
          _createElementVNode("div", {
            class: "blue",
            label: 
                            _ctx.gtype === 1
                                ? _ctx.t('baccarat.player')
                                : _ctx.t('dragontiger.tiger')
                        
          }, _toDisplayString(_ctx.roadMapData.blueCount), 9, _hoisted_63),
          _createElementVNode("div", {
            class: "green",
            label: _ctx.t('baccarat.tie')
          }, _toDisplayString(_ctx.roadMapData.tieCount), 9, _hoisted_64),
          (_ctx.gtype === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "red",
                label: _ctx.t('common.pair')
              }, _toDisplayString(_ctx.roadMapData.redPairCount), 9, _hoisted_65))
            : _createCommentVNode("", true),
          (_ctx.gtype === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "blue",
                label: _ctx.t('common.pair')
              }, _toDisplayString(_ctx.roadMapData.bluePairCount), 9, _hoisted_66))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _createVNode(_component_prediction, {
          label: 
                        _ctx.gtype === 1
                            ? _ctx.t('baccarat.banker')
                            : _ctx.t('dragontiger.dragon')
                    ,
          color: 'red',
          "map-data": _ctx.nextRedRoadMapSummaryData,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.predict(1)))
        }, null, 8, ["label", "map-data"]),
        _createVNode(_component_prediction, {
          label: 
                        _ctx.gtype === 1
                            ? _ctx.t('baccarat.player')
                            : _ctx.t('dragontiger.tiger')
                    ,
          color: 'blue',
          "map-data": _ctx.nextBlueRoadMapSummaryData,
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.predict(2)))
        }, null, 8, ["label", "map-data"])
      ]),
      (
                    _ctx.showCardDisplay &&
                    _ctx.deviceOrientation === 'landscape' &&
                    typeof _ctx.deskData !== 'undefined'
                )
        ? (_openBlock(), _createBlock(_component_card_result, {
            key: 0,
            class: "card-result",
            gameType: _ctx.deskData?.gameType ?? 1,
            onShowResult: _ctx.handleShowGameResult
          }, null, 8, ["gameType", "onShowResult"]))
        : _createCommentVNode("", true),
      (
                    _ctx.showCardDisplay &&
                    _ctx.deviceOrientation !== 'landscape' &&
                    typeof _ctx.deskData !== 'undefined'
                )
        ? (_openBlock(), _createBlock(_component_m_card_result, {
            key: 1,
            class: "m-card-result",
            gameType: _ctx.deskData?.gameType ?? 1,
            onShowResult: _ctx.handleShowGameResult
          }, null, 8, ["gameType", "onShowResult"]))
        : _createCommentVNode("", true)
    ])
  ]))
}